<template>
	<ppe-form 
		entityName="D1"
		title="D1. Protocole de sécurité" 
		title-field="{operation.code}, {operation.operationname}"
 	  sub-title=""

		:schema="schema" 
		:endpoint="endpoint"
		:redirect="'/ppe_ee/operation_home/:operationid'" 
		>

	</ppe-form>
</template>
<script>
 
import Business from 'ppe-business'
import Utils    from '../ppe/utils'

export default {
	data() {
		console.log("this.$route.params.operationid", this.$route.params.operationid)
		return {
			endpoint : "/ee/d1?id=" + this.$route.params.id+'&operationid='+this.$route.query.operationid+"&companyid="+this.$route.query.companyid,
			schema : [
				// { card:"Référent COVID",
				// 	body:[
				// 		{name:"covidOfficer.name",    label:"Responsable COVID 19",  type: "text",     size: 'Medium'},
				// 		{name:"covidOfficer.phone",   label:"Portable",  type: "text",     size: 'small'},
				// 		{name:"covidOfficer.email",   label:"Email",  type: "text",     size: 'small'},
				// 	],
				// },
				
				{ card:"Risques particuliers liés aux lieux de chargement / déchargement", 
					body:[
						{name:"risksLoadUnload",       label:'',         type:"checkboxtable", displayIndex:true,  size:'large',
								columns: ['#','', 'Risques particuliers d’interférences','MESURES DE PRÉVENTION'],
								options:Business.risksLoadUnload}
					],
				},

				{ card: "Immatriculation des véhicules de l'EE",
					body : [
						{
							type:'group', repeatable: true,
							name: 'vehicleRegistration',  label : 'Indiquez le type et l\'immatriculation des véhicules intervant sur le site ?',
							addLabel: 'Ajouter un véhicule', validation : "min:0,length", size:'large',
							children:[
									{ component: 'div', class:'display-inline', children:[
										{name:"type",   		   label:"Type de véhicule",          type: "select",   validation: 'required', class:'col-md-3', options:Business.VehicleType },
										{name:"plate",   		   label:"Immatriculation",           type: "text",     validation: 'required', class:'col-md-3'},
										{name:"model",   		   label:"Modèle",                    type: "text",     validation: '', class:'col-md-3'},
										{name:"layout", 		   label:"Spécificité",               type: "select",   validation: '', class:'col-md-3', options:Business.VehicleLayout },
									]}
							]
						},
					]
				},

				{ card:"Nature et conditionnement des marchandises", 
					body:[
						{name:"goodsNature",    label:"Nature des marchandises",  type: "textarea",  size: 'large'},
						{name:"goodsConditions",label:"Etat des marchandises",    type: "checkbox",  size:'medium', 
							options: Business.goodsConditions },
						{name:"goodsPackaging", label:"Conditionnement des marchandises",    type: "checkbox",  size:'medium', 
							options: Business.goodsPackaging, },
						{name:"goodsOtherPackaging",    label:"Autres conditionnements",     type: "textarea",  size: 'large'},
						{name:"goodsOperation", label:"Opération", type:"checkbox", 
							options: Business.goodsOperation }
					],
				},

				{ card:"Moyens de manutention", 
					body:[
						{name:"manutentionMeans",       label:'',         type:"checkbox", displayIndex:true,  size:'large',
								options: Business.manutentionMeans }
					],
				},
				
				Utils.getGetManagerCard(),
				Utils.getAdminCard(),
				],

		}
	},

};
</script>
<style>
.display-inline {
	display:   flex;
	flex-wrap: wrap;
}

.formulate-input-element-checkboxtable .formulate-input-label {
	/*white-space:nowrap;*/
	min-width: 40%;
}
</style>
